import api from '@api';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getReceivingsGridFetchSuccess, getReceivingsGridFetchFailure } from './reducer';
import { ReceivingsGridResType } from 'src/types/receivingsGrid';
import { GridRequestType } from 'src/types/table';
import { RootStoreType } from 'src/types/store';

export const RECEIVING_GRID_URL = 'api/secure/receivings/grid';
export const RECEIVING_GRID_ALL_PROVIDERS_URL = 'api/secure/receivings/grid-all-providers';
export const RECEIVING_GRID_PRODUCTS_URL = 'api/secure/receivings/receivingsProducts';

export interface GetReceivingGridCallPayloadType {
    params: GridRequestType;
    allProviders: boolean;
}

const getReceivingsGridFetchRequest = async (payload: GetReceivingGridCallPayloadType) => {
    const res = await api(
        'post',
        payload.allProviders ? RECEIVING_GRID_ALL_PROVIDERS_URL : RECEIVING_GRID_URL,
        payload.params
    );
    return res.data.data;
};

function* getReceivingsGridFetch(action: { type: string; payload?: GetReceivingGridCallPayloadType }) {
    try {
        let payloadData: GetReceivingGridCallPayloadType | undefined = action.payload;
        if (!payloadData) {
            const params: GridRequestType = yield select((state: RootStoreType) => state.receivingsGrid.data?.request);
            const allProviders: boolean = yield select((state: RootStoreType) => state.receivingsGrid.allProviders);
            if (params) {
                payloadData = {
                    params,
                    allProviders,
                };
            }
        }
        if (payloadData) {
            // @ts-ignore
            const response: ReceivingsGridResType = yield call((): any => getReceivingsGridFetchRequest(payloadData));
            yield put(getReceivingsGridFetchSuccess(response));
        } else {
            yield put(getReceivingsGridFetchFailure({ error: null }));
        }
    } catch (error) {
        yield put(getReceivingsGridFetchFailure({ error }));
    }
}

export function* getReceivingsGridFetchWatch() {
    yield takeEvery('receivingsGrid/getReceivingsGridFetch', getReceivingsGridFetch);
}
